import { useEffect } from 'react';

import { APP_DISPLAY_NAME } from '@gb-ticket/shared-types';

const TITLE_SUFFIX = APP_DISPLAY_NAME;

/**
 * Sets `document.title` to `${title} · ${APP_DISPLAY_NAME}` for the mounted page
 * and restores the previous title on unmount. Call from remaining admin pages
 * the same way when they get a dedicated title.
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · ${TITLE_SUFFIX}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
